;(function (angular, _) {
  'use strict'

  const ERRORS = {
    MISSING_LINE_ACCOUNT: 'MISSING_LINE_ACCOUNT',
    MISSING_VAT_ACCOUNT: 'MISSING_VAT_ACCOUNT',
    MISSING_CLIENT_ACCOUNT: 'MISSING_CLIENT_ACCOUNT'
  }

  class LedgerErrorHandlerController {
    // DI
    $q
    $rootScope
    creditNoteManager
    invoiceManager
    ledgerService
    utilService
    vatAccountService
    // Locals
    invoiceErrors = []
    creditNoteErrors = []
    vatErrors = []
    loading = false
    clientAccountErrors = []

    constructor (
      // Angular
      $q, $rootScope,
      // Libs
      // Managers
      CreditNoteManager, InvoiceManager,
      // Services
      LedgerService, UtilService, VatAccountService
      // Const
      // Resolved
    ) {
      this.$q = $q
      this.$rootScope = $rootScope
      this.creditNoteManager = CreditNoteManager
      this.invoiceManager = InvoiceManager
      this.ledgerService = LedgerService
      this.utilService = UtilService
      this.vatAccountService = VatAccountService
    }

    $onInit () {
      // Désinscription dans $onDestroy : sinon $rootScope garde le composant en mémoire
      this.unbindLineFixed = this.$rootScope.$on('ledger-line-error:fixed', (event, error, kind) => {
        this._lineUpdated(error, kind)
      })
    }

    $onDestroy () {
      if (this.unbindLineFixed) this.unbindLineFixed()
    }

    $onChanges (changes) {
      if (changes?.errors?.currentValue) {
        const errors = changes?.errors?.currentValue
        const lineErrors = errors.filter(({ type }) => type === ERRORS.MISSING_LINE_ACCOUNT)
        // Get unique missing vat accounts
        this.vatErrors = [...new Set(errors.filter(({ type }) => type === ERRORS.MISSING_VAT_ACCOUNT).map((e) => {
          return e.data.vat
        }))]
        this.clientAccountErrors = errors.filter(({ type }) => type === ERRORS.MISSING_CLIENT_ACCOUNT)

        const invoiceErrors = []
        const creditNoteErrors = []
        for (const error of lineErrors) {
          const isCreditNote = error.data.isCreditNote
          const usedArray = (isCreditNote ? creditNoteErrors : invoiceErrors)
          const found = usedArray.find((elt) => {
            return elt._id === error.data.invoice
          })
          if (!found) {
            usedArray.push({
              _id: error.data.invoice,
              data: [error.data]
            })
          } else {
            found.data.push(error.data)
          }
        }
        this.loading = true
        this.$q.all([this._getInvoices(invoiceErrors), this._getCreditNotes(creditNoteErrors)])
          .finally(() => {
            this.loading = false
          })
      }
    }

    createVat (value) {
      return this.vatAccountService.create({ value }, false).then((account) => {
        this.vatErrors = this.vatErrors.filter((v) => v !== account.value)
        this._checkAllCleared()
      })
    }

    _checkAllCleared () {
      const vatErrorsCount = this.vatErrors.length
      const invoiceErrorsCount = this.invoiceErrors.length
      const creditNoteErrorsCount = this.creditNoteErrors.length
      const clientAccountErrorsCount = this.clientAccountErrors.length
      if (vatErrorsCount === 0 && invoiceErrorsCount === 0 && creditNoteErrorsCount === 0 && clientAccountErrorsCount === 0) {
        this.allCleared()
        return this.ledgerService.retryExport()
      }
    }

    fixClientErrors () {
      this.clientAccountErrors = []
      this._checkAllCleared()
    }

    _lineUpdated (error, kind) {
      const key = kind === 'invoice' ? 'invoiceErrors' : 'creditNoteErrors'
      this[key] = this[key].filter((e) => {
        return e.lineObject._id !== error.lineObject._id || e.invoice !== error.invoice
      })
      this._checkAllCleared()
    }

    _getInvoices (errors) {
      return this._getElement('invoice', errors)
    }

    _getCreditNotes (errors) {
      return this._getElement('creditNote', errors)
    }

    _getElement (kind = 'invoice', errors) {
      const array = errors
      let manager
      let arrayKey
      switch (kind) {
        case 'invoice':
          arrayKey = 'invoiceErrors'
          manager = this.invoiceManager
          break
        case 'creditNote':
          arrayKey = 'creditNoteErrors'
          manager = this.creditNoteManager
          break
      }
      if (!array.length) {
        return Promise.resolve([])
      }
      const query = manager.query({
        conditions: {
          _id: {
            $in: array.map(({ _id }) => _id)
          }
        },
        isArchived: 'both',
        select: '_id title ref number numberFormat date dueDate'
      })
      return manager.getAllByBatch(query).then(({ data }) => {
        const result = array.reduce((acc, error) => {
          const element = data.find(({ _id }) => _id === error._id)
          const generatedNumber = this.utilService.getInvoiceNumber(element, kind.toLowerCase(), element.numberFormat)
          return [...acc, ...error.data.map((e) => {
            return {
              ...e,
              element,
              generatedNumber
            }
          })]
        }, [])
        this[arrayKey] = result
        return result
      })
    }
  }

  LedgerErrorHandlerController.$inject = [
    // Angular
    '$q', '$rootScope',
    // Libs
    // Managers
    'CreditNoteManager', 'InvoiceManager',
    // Services
    'LedgerService', 'UtilService', 'VatAccountService'
    // Const
    // Resolved
  ]
  angular.module('kilo.common.components')
    .component('ledgerErrorHandler', {
      bindings: {
        errors: '<',
        allCleared: '&?'
      },
      controller: LedgerErrorHandlerController,
      templateUrl: '/app/common/components/ledger-error-handler/ledger-error-handler.template.html'
    })
})(window.angular, window._)
